import { render, staticRenderFns } from "./preview-product-modal.vue?vue&type=template&id=38c53bd6&scoped=true"
import script from "./preview-product-modal.vue?vue&type=script&lang=js"
export * from "./preview-product-modal.vue?vue&type=script&lang=js"
import style0 from "./preview-product-modal.vue?vue&type=style&index=0&id=38c53bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c53bd6",
  null
  
)

export default component.exports